import { UUID } from '@/types';
import DashboardFilterRef from '@/util/DashboardFilterRef';
import LayerWhere from '@/components/layers/LayerWhere';

export const getWidgetFilters = (series: UUID, filters: DashboardFilterRef[]) =>
  filters.filter((f) => f._series.includes(series));

export const getWidgetBeingEditedFilters = (
  widgetFiltersIds: UUID[],
  dashboardFilters: DashboardFilterRef[],
) => dashboardFilters.filter((f) => widgetFiltersIds.includes(f._id));

export const getIsApplied = (
  appliedFilters: LayerWhere[],
  widgetFilter: DashboardFilterRef,
) => appliedFilters.some((f) => f.lhs().name() === widgetFilter.name());

export const getClause = (name: string, appliedFilters: LayerWhere[]) =>
  appliedFilters
    .find((af) => af.lhs().name() === name)
    // @ts-expect-error: TODO: get rid of classed based layers.
    ?.buildContent(() => null, null, true);
